module.exports = __webpack_public_path__ + "img/161B1F_C7E0EC_90A5B3_7B8C9B-256px.a37a2d07.png";